import { ITEM_CONDITION_LABELS, ITEM_CONDITIONS, type ItemCondition } from '@sellit/shared';

export function ConditionSelect({ value, onChange }: { value: ItemCondition | null; onChange: (v: ItemCondition | null) => void }) {
  return (
    <label className="field">
      <span>Condition</span>
      <select value={value ?? ''} onChange={(e) => onChange((e.target.value || null) as ItemCondition | null)}>
        <option value="">Not specified</option>
        {ITEM_CONDITIONS.map((c) => (
          <option key={c} value={c}>{ITEM_CONDITION_LABELS[c]}</option>
        ))}
      </select>
    </label>
  );
}
